module.exports = __webpack_public_path__ + "static/media/APP_LifeSaver_152x174_6.9fe1e78c.png";